import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-[#B38053] text-white py-10 xs:py-12 sm:py-16">
      <div className="container mx-auto px-3 xs:px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 xs:grid-cols-2 sm:grid-cols-4 gap-6 xs:gap-8 mb-8 xs:mb-10 sm:mb-12">
          {/* Products Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="space-y-3 xs:space-y-4"
          >
            <h3 className="text-lg xs:text-xl font-semibold mb-2 xs:mb-4">Products</h3>
            <ul className="space-y-1.5 xs:space-y-2">
              <li><Link to="/products#furniture" className="text-sm xs:text-base text-white/90 hover:text-white transition-colors">Furniture</Link></li>
              <li><Link to="/products#table-decor" className="text-sm xs:text-base text-white/90 hover:text-white transition-colors">Table Decor</Link></li>
              <li><Link to="/products#serveware" className="text-sm xs:text-base text-white/90 hover:text-white transition-colors">Serveware</Link></li>
              <li><Link to="/products#wall-decor" className="text-sm xs:text-base text-white/90 hover:text-white transition-colors">Wall Decor</Link></li>
            </ul>
          </motion.div>

          {/* Company Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
            className="space-y-3 xs:space-y-4"
          >
            <h3 className="text-lg xs:text-xl font-semibold mb-2 xs:mb-4">Company</h3>
            <ul className="space-y-1.5 xs:space-y-2">
              <li><Link to="/about" className="text-sm xs:text-base text-white/90 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-sm xs:text-base text-white/90 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </motion.div>

          {/* Connect Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            viewport={{ once: true }}
            className="space-y-3 xs:space-y-4"
          >
            <h3 className="text-lg sm:text-xl font-semibold mb-2 sm:mb-4">Connect</h3>
            <div className="flex gap-3 sm:gap-4">
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/90 hover:text-white transition-colors"
              >
                <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                </svg>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/90 hover:text-white transition-colors"
              >
                <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path fillRule="evenodd" d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z" clipRule="evenodd" />
                </svg>
              </a>
            </div>
          </motion.div>

          {/* Location Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.6 }}
            viewport={{ once: true }}
            className="space-y-3 xs:space-y-4"
          >
            <h3 className="text-lg xs:text-xl font-semibold mb-2 xs:mb-4">Contact Info</h3>
            <div className="space-y-1 xs:space-y-1.5">
              <p className="text-white/90 flex items-start gap-2">
                <svg className="w-4 h-4 sm:w-5 sm:h-5 mt-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                <span>
                  <span className="block text-sm sm:text-base text-white/90">65, Solitaire Industrial Park</span>
                  <span className="block text-sm sm:text-base text-white/90">Bagru, Rajasthan</span>
                  <span className="block text-sm sm:text-base text-white/90">India - 303007</span>
                </span>
              </p>
            </div>
            <div className="pt-2 sm:pt-4">
              <p className="text-white/90 flex items-center gap-2">
                <span className="material-icons text-white/90 text-base sm:text-xl">
                  email
                </span>
                <a href="mailto:anggood.info@gmail.com" className="text-sm sm:text-base text-white/90 hover:text-white transition-colors">
                  anggood.info@gmail.com
                </a>
              </p>
              <p className="text-white/90 flex items-center gap-2 mt-1.5 sm:mt-2">
                <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M2 3a1 1 0 011-1h2.153a1 1 0 01.986.836l.74 4.435a1 1 0 01-.54 1.06l-1.548.773a11.037 11.037 0 006.105 6.105l.774-1.548a1 1 0 011.059-.54l4.435.74a1 1 0 01.836.986V17a1 1 0 01-1 1h-2C7.82 18 2 12.18 2 5V3z" />
                </svg>
                <a href="tel:+919694444893" className="text-sm sm:text-base text-white/90 hover:text-white transition-colors">
                  +91 9694444893
                </a>
              </p>
            </div>
          </motion.div>
        </div>

        {/* Copyright and Tagline */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.8 }}
          viewport={{ once: true }}
          className="text-center text-white/80 font-lora border-t border-white/20 pt-6 xs:pt-8"
        >
          <p className="text-sm xs:text-base mb-1.5 xs:mb-2">© 2025 ANG. All Rights Reserved.</p>
          <p className="text-sm xs:text-base">Lovingly Crafted, Uniquely Yours.</p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;
 